import o from"./common/chartLayoutProps.js";var r={props:o};export{r as default};
